// Flow types automatically removed

import get from 'lodash/get.js';
export const getQueryParam = (uriRef, paramName) => {
    const paramsString = get(uriRef.split('?'), '[1]');
    const searchParams = new URLSearchParams(paramsString);
    return searchParams.get(paramName);
};
